import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import {
  Button,
  Drawer,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

import axios from 'axios'
import DateRangePicker from '../../../components/DateRangePicker'
import FilterShippings from '../../../components/FiltersShippings'
import SelectSearch from '../../../components/SelectSearch'
import CategorySelectSearch from '../../../components/SelectSearch/CategorySelectSearch'
import ChannelSelectSearch from '../../../components/SelectSearch/ChannelSelectSearch'
import ProductGroupSelectSearch from '../../../components/SelectSearch/ProductGroupSelectSearch'
import ProductSelectSearch from '../../../components/SelectSearch/ProductSelectSearch'
import UserSelectSearch from '../../../components/SelectSearch/UserSelectSearch'
import { IOptionSelect } from '../../../components/SelectSearchMultiple'
import useAxios from '../../../hooks/useAxios'
import { ICategory } from '../../../types/category'
import { IDistributionChannel } from '../../../types/distribution-channel'
import {
  EORDER_STATUS_CALL,
  EOrderDateType,
  EOrderType,
} from '../../../types/order'
import { PaginationResponseInterface } from '../../../types/pagination'
import { IUserLists } from '../../../types/user'
import { validateMinMaxValue } from '../../../utils/validateMinMaxValue'
import { IFilterMapped } from './OrderFilter'

export enum EOrderOverdue {
  TRUE = 'true',
  FALSE = 'false',
  NULL = 'null',
}

export enum EStatusTypeOrderCrmTelesale {
  ORDER = 'order',
  CRM = 'crm',
  TELESALE = 'telesale',
  UPSALE = 'upsale',
}

export enum EStatusOrderShowTracking {
  TRACKING = 'tracking',
  NO_TRACKING = 'no_tracking',
  PENDING = 'pending',
  BANK = 'BANK',
  COD = 'COD',
  SHIPPED = 'shipped',
}

interface OrderFilterDrawerProps {
  isOpen: boolean
  onClose: () => void
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  hideStatusCall?: boolean
}

const menuItemsTypeDate = [
  // {
  //   label: 'ทั้งหมด',
  //   value: 'all',
  // },
  {
    label: 'วันที่คำสั่งซื้อ',
    value: EOrderDateType.ORDERDATE,
  },
  {
    label: 'วันที่สร้างคำสั่งซื้อ',
    value: EOrderDateType.CREATED,
  },
  {
    label: 'วันที่ขนส่งรับสินค้า',
    value: EOrderDateType.PICKUP,
  },
  {
    label: 'วันที่พิมพ์',
    value: EOrderDateType.PRINTED,
  },
]

const menuItemsTypeOrderStatusCRM = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'รายการคำสั่งซื้อ',
    value: EStatusTypeOrderCrmTelesale.ORDER,
  },
  {
    label: 'รายการคำสั่งซื้อ CRM',
    value: EStatusTypeOrderCrmTelesale.CRM,
  },
  {
    label: 'รายการคำสั่งซื้อ Telesale',
    value: EStatusTypeOrderCrmTelesale.TELESALE,
  },
  {
    label: 'รายการคำสั่งซื้อ Upsale',
    value: EStatusTypeOrderCrmTelesale.UPSALE,
  },
]

const menuItemsTypeTracking = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'เฉพาะรายการที่มี Tracking',
    value: EStatusOrderShowTracking.TRACKING,
  },
  {
    label: 'ยังไม่มี Tracking',
    value: EStatusOrderShowTracking.NO_TRACKING,
  },
]

const menuItemsTypePaymentMethod = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'โอนเงินผ่านธนาคาร',
    value: EOrderType.BANK,
  },
  {
    label: 'เก็บเงินปลายทาง',
    value: EOrderType.COD,
  },
]

const menuItemsStatusCall = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'โทรแล้ว',
    value: EORDER_STATUS_CALL.CALLED,
  },
  {
    label: 'ไม่รับสาย',
    value: EORDER_STATUS_CALL.CANCELLED,
  },
  {
    label: 'ยังไม่โทร',
    value: EORDER_STATUS_CALL.NOT_CALLED,
  },
]

interface ICity {
  id: number
  name_th: string
  name_en: string
  geography_id: number
  created_at: string
  updated_at: string
  deleted_at: string | null
}

const OrderFilterDrawer = (props: OrderFilterDrawerProps) => {
  const {
    isOpen,
    onClose,
    onFilterChange,
    filter,
    onSearch,
    hideStatusCall = false,
  } = props
  const {
    page,
    perPage,
    search,
    startDate,
    endDate,
    categories,
    products,
    productGroups,
    distributionChannels,
    minTotal,
    maxTotal,
    statusShowCrmTelesale,
    dateType,
    paymentMethod,
    province,
    telesale,
    overdue,
    statusOrderShowTracking,
    statusCall,
    status,
    ignoreCancel = 'false',
  } = filter
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [provinceList, setProvinceList] = useState<ICity[]>([])
  const [searchProvince, setSearchProvince] = useState<string>('')
  const [searchActor, setSearchActor] = useState<string>('')
  const [searchComission, setSearchComission] = useState<string>('')
  const [searchUserTelesale, setSearchUserTelesale] = useState<string>('')
  const [searchCategory, setSearchCategory] = useState<string>('')
  const [searchDistributionChannel, setSearchDistributionChannel] =
    useState<string>('')
  const [resetAutoComplete, setResetAutoComplete] = useState<string>('')

  const handleFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      onFilterChange({ ...filter, ...newFilter })
    },
    [filter, onFilterChange],
  )

  const handleReset = useCallback(() => {
    onFilterChange({
      page: 1,
      perPage: 15,
      status,
    })
    onSearch({
      page: 1,
      perPage: 15,
      status,
    })
    setResetAutoComplete(new Date().getTime().toString())
  }, [page, perPage, onFilterChange, onSearch])

  const categoriesList = useAxios<PaginationResponseInterface<ICategory>>({
    method: 'GET',
    url: '/category',
    params: {
      page: 1,
      perPage: 5,
      search: searchCategory,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchCategory = async (value: string) => {
    setSearchCategory(value)
    await categoriesList.mutate()
  }

  const distributionChannelsList = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 5,
      search: searchDistributionChannel,
      startDate: '',
      endDate: '',
    },
  })

  const actorsList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchActor,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchActor = async (value: string) => {
    setSearchActor(value)
    try {
      await actorsList.mutate()
    } catch (error) {}
  }

  const comissionsList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchComission,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchComission = async (value: string) => {
    setSearchComission(value)
    try {
      await comissionsList.mutate()
    } catch (error) {}
  }

  const userTeleSaleList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserTelesale,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchUserTelesale = async (value: string) => {
    setSearchUserTelesale(value)
    try {
      await userTeleSaleList.mutate()
    } catch (error) {}
  }

  const handleSearchDistributionChannel = async (value: string) => {
    setSearchDistributionChannel(value)
    try {
      await distributionChannelsList.mutate()
    } catch (error) {}
  }

  useEffect(() => {
    const fetchProvince = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_FORMAT_PROVINCE_URL}`,
        )
        setProvinceList(response.data)
      } catch (error) {
        console.error('Error fetching province', error)
      }
    }
    fetchProvince()
  }, [])

  return (
    <Drawer
      anchor={'right'}
      keepMounted
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: {
          width: isMobile ? '80%' : '40%',
          maxWidth: isMobile ? '80%' : '40%',
        },
      }}
    >
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12} lg={4}>
          <TextField
            label={'ค้นหาจาก'}
            fullWidth
            id="searchType"
            name="searchType"
            variant="filled"
            value={filter.searchType || 'customer_name'}
            onChange={(e) => handleFilterChange({ searchType: e.target.value })}
            select
          >
            <MenuItem value="order_id">รหัสคำสั่งซื้อ</MenuItem>
            <MenuItem value="order_code">เลขออเดอร์ </MenuItem>
            <MenuItem value="customer_name">ชื่อลูกค้า</MenuItem>
            <MenuItem value="customer_phone">หมายเลขโทรศัพท์</MenuItem>
            <MenuItem value="tracking_number">หมายเลขพัสดุ</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} lg={8}>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            label={'คำค้น'}
            fullWidth
            id="search"
            name="search"
            autoFocus
            variant="filled"
            value={search || ''}
            onChange={(e) => handleFilterChange({ search: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            label={'ค้นหาจากหมายเลขพัสดุ (ค้นหาได้จากเลขพัสดุ เก่าและใหม่)'}
            fullWidth
            id="trackingNumber"
            name="trackingNumber"
            autoFocus
            variant="filled"
            value={filter.trackingNumber || ''}
            onChange={(e) =>
              handleFilterChange({ trackingNumber: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <FilterShippings
            onFilterChange={handleFilterChange}
            filter={filter}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <ProductSelectSearch
            products={products}
            resetAutoComplete={resetAutoComplete}
            handleFilterChange={handleFilterChange}
            onSelect={(e) => {
              const selectedIds = e?.map(
                (product: any) => product?.value?.objectId,
              )
              onFilterChange({ ...filter, products: selectedIds })
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <ProductGroupSelectSearch
            resetAutoComplete={resetAutoComplete}
            productGroups={productGroups}
            onSelect={(e) => {
              const selectedGroupIds = e?.map((group) => group.value.objectId)
              onFilterChange({ ...filter, productGroups: selectedGroupIds })
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          {/* <SelectSearchMultiple<ICategory>
            resetAutoComplete={resetAutoComplete}
            placeholder={'เลือกหมวดหมู่สินค้า'}
            label={'เลือกหมวดหมู่สินค้า'}
            onSelect={(e) => {
              const selectedCategoryIds = e?.map(
                (category) => category?.value?.name,
              )
              onFilterChange({ ...filter, categories: selectedCategoryIds })
            }}
            search={searchCategory}
            onSearch={handleSearchCategory}
            options={
              categoriesList.data?.records
                .filter(
                  (category: ICategory) => !categories?.includes(category.name),
                )
                .map(
                  (category: ICategory) =>
                    category.isAvailable && {
                      label: category.name,
                      value: category,
                    },
                )
                .reduce((acc: IOptionSelect<ICategory>[], category) => {
                  if (category) {
                    acc.push(category)
                  }
                  return acc
                }, []) || ([] as IOptionSelect<ICategory>[])
            }
          /> */}
          <CategorySelectSearch
            resetAutoComplete={resetAutoComplete}
            categories={categories}
            onSelect={(e) => {
              const selectedCategoryIds = e?.map(
                (category: any) => category?.value?.objectId,
              )
              onFilterChange({ ...filter, categories: selectedCategoryIds })
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label={'สีสินค้า (พิมพ์ให้ตรงกับที่บันทึกไว้)'}
            fullWidth
            id="colors"
            name="colors"
            variant="filled"
            value={filter.colors || ''}
            onChange={(e) => handleFilterChange({ colors: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label={'ขนาดสินค้า (พิมพ์ให้ตรงกับที่บันทึกไว้)'}
            fullWidth
            id="sizes"
            name="sizes"
            variant="filled"
            value={filter.sizes || ''}
            onChange={(e) => handleFilterChange({ sizes: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          {/* <SelectSearchMultiple<IDistributionChannel>
            resetAutoComplete={resetAutoComplete}
            placeholder={'เลือกช่องทางการขาย'}
            label={'เลือกช่องทางการขาย'}
            onSelect={(e) => {
              const selectedChannelIds = e?.map(
                (channel) => channel?.value?.objectId,
              )
              onFilterChange({
                ...filter,
                distributionChannels: selectedChannelIds,
              })
            }}
            search={searchDistributionChannel}
            onSearch={handleSearchDistributionChannel}
            options={
              distributionChannelsList.data?.records
                .filter(
                  (distributionChannel: IDistributionChannel) =>
                    !distributionChannels?.includes(
                      distributionChannel.objectId,
                    ),
                )
                .map((distributionChannel: IDistributionChannel) => ({
                  label: distributionChannel.name,
                  value: distributionChannel,
                })) || ([] as IOptionSelect<IDistributionChannel>[])
            }
          /> */}
          <ChannelSelectSearch
            resetAutoComplete={resetAutoComplete}
            label={'เลือกช่องทางการขาย'}
            onSelect={(e) => {
              const selectedChannelIds = e?.map(
                (channel: any) => channel?.value?.objectId,
              )
              onFilterChange({
                ...filter,
                distributionChannels: selectedChannelIds,
              })
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="statusShowCrmTelesale-label">
              ประเภทสถานะคำสั่งซื้อ
            </InputLabel>
            <Select
              id="statusShowCrmTelesale"
              name="statusShowCrmTelesale"
              labelId="statusShowCrmTelesale-label"
              value={statusShowCrmTelesale || ''}
              onChange={(e) =>
                handleFilterChange({
                  statusShowCrmTelesale: e?.target
                    .value as EStatusTypeOrderCrmTelesale,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>เลือกประเภทสถานะคำสั่งซื้อ</em>
              </MenuItem>
              {menuItemsTypeOrderStatusCRM.map((item, index: number) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="statusOrderShowTracking-label">
              สถานะ tracking
            </InputLabel>
            <Select
              id="statusOrderShowTracking"
              name="statusOrderShowTracking"
              labelId="statusOrderShowTracking-label"
              value={statusOrderShowTracking || ''}
              onChange={(e) =>
                handleFilterChange({
                  statusOrderShowTracking: e?.target
                    .value as EStatusOrderShowTracking,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>เลือกสถานะ</em>
              </MenuItem>
              {menuItemsTypeTracking.map((item, index: number) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={12}>
          <DateRangePicker
            startDate={startDate}
            endDate={endDate}
            onChange={(startDate, endDate) => {
              handleFilterChange({ startDate, endDate })
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="dateType-label">ค้นหาจากวันที่</InputLabel>
            <Select
              id="dateType"
              name="dateType"
              labelId="dateType-label"
              value={dateType || ''}
              onChange={(e) =>
                handleFilterChange({
                  dateType: e?.target.value as EOrderDateType,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>เลือกรายการค้นหาจากวันที่</em>
              </MenuItem>
              {menuItemsTypeDate.map((item, index: number) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="paymentMethod-label">รูปแบบการชำระเงิน</InputLabel>
            <Select
              id="paymentMethod"
              name="paymentMethod"
              labelId="paymentMethod-label"
              value={paymentMethod || ''}
              onChange={(e) =>
                handleFilterChange({
                  paymentMethod: e?.target.value as EOrderType,
                })
              }
              fullWidth
            >
              <MenuItem disabled value="" selected>
                <em>เลือกรายการรูปแบบการชำระเงิน</em>
              </MenuItem>
              {menuItemsTypePaymentMethod.map((item, index: number) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="filled" fullWidth>
            <InputLabel id="ignoreCancel-label">ไม่รวมสินค้ายกเลิก</InputLabel>
            <Select
              id="ignoreCancel"
              name="ignoreCancel"
              labelId="ignoreCancel-label"
              value={ignoreCancel}
              onChange={(e) =>
                handleFilterChange({
                  ignoreCancel: e?.target.value,
                })
              }
              fullWidth
            >
              <MenuItem value={'true'}>ไม่รวม</MenuItem>
              <MenuItem value={'false'}>รวม</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <SelectSearch<ICity>
            resetAutoComplete={resetAutoComplete}
            label={'เลือกจังหวัด'}
            search={searchProvince}
            onSearch={setSearchProvince}
            onSelect={(e) => {
              handleFilterChange({ province: e?.value.name_th })
            }}
            options={
              provinceList.map((province: ICity) => ({
                label: province.name_th,
                value: province,
              })) || ([] as IOptionSelect<ICity>[])
            }
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <UserSelectSearch
            resetAutoComplete={resetAutoComplete}
            label={'เลือกคนสร้างคำสั่งซื้อ'}
            onSelect={(e) => handleFilterChange({ actor: e?.value.username })}
            name="actor"
          />
        </Grid>
        {/* <Grid item xs={12} lg={6}>
          <SelectSearch<IUserLists>
            label={'เลือกคนรับคำสั่งซื้อ'}
            onSelect={(e) => handleFilterChange({ comission: e?.value.username })}
            search={searchComission}
            onSearch={handleSearchComission}
            options={
              comissionsList.data?.records.map((userTelesales: IUserLists) => ({
                label: userTelesales.name,
                image: userTelesales.image,
                value: userTelesales,
              })) || [] as IOptionSelect<IUserLists>[]
            } />
        </Grid> */}
        <Grid item xs={12} lg={6}>
          {/* <SelectSearch<IUserLists>
            resetAutoComplete={resetAutoComplete}
            label={'คนรับคอมมิชชั่น'}
            onSelect={(e) =>
              handleFilterChange({ comission: e?.value.username })
            }
            search={searchComission}
            onSearch={handleSearchComission}
            options={
              comissionsList.data?.records
                .filter(
                  (userTelesales: IUserLists) => userTelesales.isAvailable,
                )
                .map((userTelesales: IUserLists) => ({
                  label: userTelesales.name,
                  image: userTelesales.image,
                  value: userTelesales,
                })) || ([] as IOptionSelect<IUserLists>[])
            }
          /> */}
          <UserSelectSearch
            resetAutoComplete={resetAutoComplete}
            label={'คนรับคอมมิชชั่น'}
            onSelect={(e) =>
              handleFilterChange({ comission: e?.value.username })
            }
            name="comission"
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <SelectSearch<IUserLists>
            resetAutoComplete={resetAutoComplete}
            label={'เลือกคนดูแล Telesale'}
            onSelect={(e) =>
              handleFilterChange({ assignTelesaleBy: e?.value.username })
            }
            search={searchUserTelesale}
            onSearch={handleSearchUserTelesale}
            options={
              userTeleSaleList.data?.records
                .filter(
                  (userTelesales: IUserLists) => userTelesales.isAvailable,
                )
                .map((userTelesales: IUserLists) => ({
                  label: userTelesales.name,
                  image: userTelesales.image,
                  value: userTelesales,
                })) || ([] as IOptionSelect<IUserLists>[])
            }
          /> */}
          <UserSelectSearch
            resetAutoComplete={resetAutoComplete}
            label={'เลือกคนดูแล Telesale'}
            onSelect={(e) =>
              handleFilterChange({ assignTelesaleBy: e?.value.username })
            }
            name="assignTelesaleBy"
          />
        </Grid>
        <Grid item xs={6} lg={6}>
          <TextField
            fullWidth
            id="minTotal"
            name="minTotal"
            label={'ช่วงราคา (น้อยที่สุด)'}
            variant={'filled'}
            type={'number'}
            value={filter.minTotal || ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                minTotal:
                  validateMinMaxValue(e.target.value, 0, 999999) || undefined,
              })
            }
          />
        </Grid>
        <Grid item xs={6} lg={6}>
          <TextField
            fullWidth
            id="maxTotal"
            name="maxTotal"
            label={'ช่วงราคา (มากที่สุด)'}
            variant={'filled'}
            type={'number'}
            value={filter.maxTotal || ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                maxTotal:
                  validateMinMaxValue(e.target.value, 0, 999999) || undefined,
              })
            }
          />
        </Grid>
        <Grid item xs={6} lg={6}>
          <TextField
            fullWidth
            id="quantity"
            name="quantity"
            label={'จำนวนสินค้า'}
            variant={'filled'}
            type={'number'}
            value={filter.quantity || ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                quantity:
                  validateMinMaxValue(e.target.value, 1, 1000) || undefined,
              })
            }
          />
        </Grid>
        {!hideStatusCall && (
          <Grid item xs={6} lg={6}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="statusCall-label">สถานะการโทร</InputLabel>
              <Select
                id="statusCall"
                name="statusCall"
                labelId="statusCall-label"
                value={statusCall || ''}
                onChange={(e) =>
                  handleFilterChange({
                    statusCall: e?.target.value,
                  })
                }
                fullWidth
              >
                <MenuItem disabled value="" selected>
                  <em>เลือกสถานะการโทร</em>
                </MenuItem>
                {menuItemsStatusCall.map((item, index: number) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={9} lg={9}>
          <Button
            color="primary"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => onSearch(filter)}
            sx={{ height: '100%' }}
          >
            ค้นหา
          </Button>
        </Grid>
        <Grid item xs={3} lg={3}>
          <Button
            color="inherit"
            size="large"
            fullWidth
            variant="contained"
            startIcon={!isMobile && <ClearIcon />}
            onClick={() => handleReset()}
            sx={{ height: '100%' }}
          >
            {isMobile ? <ClearIcon /> : 'รีเซ็ต'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  )
}

export default OrderFilterDrawer
